import Button from "../../../../../components/elements/Button/Button";
import {useIntl} from "react-intl";
import React, {useEffect, useState} from "react";
import {useNavigate, useOutletContext, useParams} from "react-router-dom";
import {toast} from "react-toastify";
import axios from "axios";
import errorParser from "../../../../../components/ErrorParser/ErrorParser";
import "./DrinksMenu.scss"
import LoadingComp from "../../../../../components/elements/LoadingComp/LoadingComp";
import AddDrinkMenuForm from "./AddDrinkMenuForm";

export default function EditDrinksMenu() {

    const intl = useIntl();
    let params = useParams();
    const navigate = useNavigate()
    const jwt = localStorage.getItem('jwt')

    const [title, setTitle] = useState('')
    const [price, setPrice] = useState(0)
    const [cost, setCost] = useState(0)
    const [percentagePriceNonAlcoholic, setPercentagePriceNonAlcoholic] = useState(0)
    const [percentagePriceAlcoholic, setPercentagePriceAlcoholic] = useState(0)
    const [priceAlcoholic, setPriceAlcoholic] = useState(0)
    const [priceNonAlcoholic, setPriceNonAlcoholi] = useState(0)
    const [vat, setVat] = useState(0)
    const [vatNonAlcoholic, setVatNonAlcoholic] = useState(0)
    const [eventType, setEventType] = useState([])
    const [eventTypes, setEventTypes] = useState([])
    const [menus, setMenus] = useState([])

    const [loading, setLoading] = useState(true)

    const [saveLoading, setSaveLoading] = useState(false)
    const {context} = useOutletContext()
    useEffect(() => {
        getData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const getData = async () => {
        axios.get(process.env.REACT_APP_API + '/drink-menus/' + params.id, {
            headers: {
                'Authorization': 'Bearer ' + jwt
            }
        })
            .then(async (response) => {
                if (response.data) {
                    setTitle(response.data.title)
                    setPrice(response.data.price)
                    setCost(response.data.cost ?? 0)
                    setPercentagePriceNonAlcoholic(response.data.percentage_price_non_alcoholic ?? parseFloat(response.data.price_non_alcoholic/response.data.price).toFixed(2))
                    setPercentagePriceAlcoholic(response.data.percentage_price_alcoholic ?? parseFloat(response.data.price_alcoholic/response.data.price).toFixed(2))
                    setPriceAlcoholic(response.data.price_alcoholic)
                    setPriceNonAlcoholi(response.data.price_non_alcoholic)
                    setVat(response.data.vat)
                    setVatNonAlcoholic(response.data.vat_non_alcoholic)
                    setEventType(response.data.event_types.map(item => item.id))
                    setMenus(response.data.items)
                    getEventTypes(response.data.used_in_event_types)
                }
            })
            .catch(err => {
                errorParser(err, intl)
            })
    }

    const getEventTypes = async (usedInEventTypes = []) => {
        axios.get(process.env.REACT_APP_API + '/event-types' , {
            headers: {
                'Authorization': 'Bearer ' + jwt
            }
        })
            .then(async (response) => {
                let temp = []
                for (let i=0; i < response.data.length; i++){
                    temp.push({
                        value: response.data[i].id,
                        label: intl.formatMessage({id: 'general.event_type.' + response.data[i].title}),
                        disabled: usedInEventTypes.includes(response.data[i].title),
                        isFixed: usedInEventTypes.includes(response.data[i].title)
                    })
                }
                setEventTypes(temp)
                setLoading(false)
            })
            .catch(err => {
                errorParser(err, intl)
            })
    }
    const save = async (e) => {
        e.preventDefault();
        if (vat === 0 || (priceNonAlcoholic === 0 && priceAlcoholic === 0 && price === 0)) {
            toast.error(intl.formatMessage({id: "errors.please_fill_all_fields"}))
            return
        }
        setSaveLoading(true)

        let payload = {
            title: title,
            price_alcoholic: priceAlcoholic,
            price_non_alcoholic: priceNonAlcoholic,
            event_types: eventType,
            items: menus,
            vat,
            vat_non_alcoholic: vatNonAlcoholic,
            price,
            cost,
            percentage_price_non_alcoholic: percentagePriceNonAlcoholic,
            percentage_price_alcoholic: percentagePriceAlcoholic
        }

        await axios.put(process.env.REACT_APP_API + '/drink-menus/' + params.id, payload, {
            headers: {
                'Authorization': 'Bearer ' + jwt
            }
        })
            .then(async (response) => {
                toast.success(intl.formatMessage({id: 'errors.success.data_has_been_saved'}))
                context.setContentUpdated(false)
                navigate(-1)
            })
            .catch(err => {
                errorParser(err, intl)
            })


        setSaveLoading(false)
    }

    if (loading) {
        return <LoadingComp/>
    }

    return (
        <div className="card">
            <div className={"header"}><p>{intl.formatMessage({id: 'menus.edit_drinks_menu'})}</p></div>
            <form onSubmit={(e) => save(e)}>
                <div className={"content"}>
                    <AddDrinkMenuForm
                        title={title} setTitle={setTitle} eventTypes={eventTypes} eventType={eventType} setEventType={setEventType}
                        price={price} setPrice={setPrice} percentagePriceNonAlcoholic={percentagePriceNonAlcoholic}
                        setPercentagePriceNonAlcoholic={setPercentagePriceNonAlcoholic} percentagePriceAlcoholic={percentagePriceAlcoholic}
                        setPercentagePriceAlcoholic={setPercentagePriceAlcoholic} priceAlcoholic={priceAlcoholic} setPriceAlcoholic={setPriceAlcoholic}
                        priceNonAlcoholic={priceNonAlcoholic} setPriceNonAlcoholi={setPriceNonAlcoholi} vat={vat} setVat={setVat}
                        vatNonAlcoholic={vatNonAlcoholic} setVatNonAlcoholic={setVatNonAlcoholic} menus={menus} setMenus={setMenus}
                        cost={cost} setCost={setCost}
                    />
                </div>

                <div className={"footer"}>
                    <div className={"row"}>
                        <div className={"col-12 col-md-6"}>
                            <Button
                                className={"btn-light mt-2"}
                                icon={"fa-solid fa-chevron-left"}
                                value={intl.formatMessage({id: 'general.buttons.back'})}
                                onClick={() => {
                                    context.setLeavePage(true)
                                    context.setNextLink('/menus/drink-menus')
                                }}
                            />
                        </div>
                        <div className={"col-12 col-md-6 d-flex"}>
                            <Button
                                className={"btn-secondary mt-2 ms-auto"}
                                icon={"fa-regular fa-floppy-disk"}
                                value={intl.formatMessage({id: 'general.buttons.save'})}
                                disabled={saveLoading}
                                loading={saveLoading}
                                type={'submit'}
                            />
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
}

